/**
 * 任务各种状态
 * @description
 *  定义状态时，应当慎重！！！
 *  状态只可为 n或者adj，不可为v
 *  状态只可为 n或者adj，不可为v
 *  状态只可为 n或者adj，不可为v
 *  状态只可为 n或者adj，不可为v
 */
export enum TaskStatus {
  // 等待中
  waiting = 'waiting',
  // 运行中
  running = 'running',
  // 暂停中
  paused = 'paused',
  error = 'error',
  success = 'success',
  // 已被取消
  canceled = 'canceled',
  finish = 'finish',
  // 检查通过后
  ready = 'ready',
  // 检查失败后
  unReady = 'unReady',
  // 文件IO处理中
  preparing = 'preparing',
  checking = 'checking',
}

/**
 * 动作枚举
 * @description 目前只是定义，还没有开始使用
 */
enum TaskAction {
  // 开始任务
  START = 'START',
  // 暂停任务
  PAUSE = 'PAUSE',
  // 恢复任务
  RESUME = 'RESUME',
  // 完成任务
  COMPLETE = 'COMPLETE',
  // 取消任务
  CANCEL = 'CANCEL',
  // 重试任务
  RETRY = 'RETRY',
  // 错误任务
  REJECT = 'REJECT',
}

/**
 * @description 子任务
 * @export
 * @enum {number}
 */
export interface SubTask<T> {
  id: string; // 无意义唯一编码 例如：id_xxxx
  taskId: string; // 子任务属于哪个批量任务
  title: string; // 子任务的标题，例如： 上传的文件名称，复制的文件名称等
  status: TaskStatus; // 子任务的状态，例如： waiting, init, running, paused, success, error

  loaded?: number; // 子任务已经加载的byte size
  percent: number; // 子任务的进度百分比，类型为 Number
  ioPercent?: number | undefined; // 子任务的进度百分比，类型为 Number
  hashPercent?: number; // 上传/下载任务需要，表示当前文件 hash 校验进度; 目前暂未使用
  speed: number; // 子任务的速率，单位为 byte/s
  info: T;
  ins?: any; // 用于挂载实例，上传实例/下载实例
  remainingTime: number;
  remainingMessage: string;
  error?: any; // 子任务失败的原因

  isQuickUpload?: boolean; // 是否秒传
}

/**
 * @description 任务
 * @export
 * @enum {number}
 */
export interface Task<T> {
  id: string; // 无意义的唯一标示
  taskId: string; // 批量任务 ID，addTask 时自动生成
  action: string; // 批量任务的动作 upload/download/copy/delete....
  title: string; // 批量任务的标题

  // list: SubTask<T>[];
  getList: () => SubTask<T>[];
  getListLength: () => number;
  getItem: (index: number) => SubTask<T>;
  sortListByStatus: () => void;
  size?: number; // 如果是上传/下载任务，则表示当前任务的文件(文件夹)大小
  isDir?: boolean; // 标记当前任务是否为文件夹任务

  status: TaskStatus; // 批量任务的状态，例如： waiting, running, paused, success, error
  progressText: string; // 批量任务的进度文案，例如： （50/100）,（成功 10 个，失败 0 个）
  // IO进度条
  ioPercent?: number | undefined;
  speed?: number; // 批量任务的总速度
  finishDate?: number; // 任务结束的时间戳
  error?: any; // 任务发生错误

  // percent; // 批量任务的进度百分比
  // speed: number; // 批量任务的速率，例如： 100MB/S

  successNum?: number; // 批量任务的成功数量
  errorNum?: number; // 批量任务的失败数量
  totalNum?: number; // 批量任务的总数量
  // 操作方法
  // onStart?: Function; // 任务开始操作,必须
  // onRetry?: Function; // 点击了重试，非必须
  // onPause?: Function; // 点击暂停，非必须
  // onRestart?: Function; // 点击了重新启动，非必须
  // onCancel?: Function; // 点击取消，非必须
  // onDelete?: Function; // 点击了删除，非必须
  // onUpdateProgress?: Function; // 当触发更新操作时，如何更新全局状态，必须
  isQuickUpload?: boolean; // 是否秒传
  hashPercent?: number; // 上传/下载任务需要，表示当前文件 hash 校验进度
}
